import useAccessProjectAsManagerMutation from 'src/new_arch/modules/projects/queries/useAccessProjectAsManagerMutation';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import Project from 'src/entities/project';

const useAccessProjectAsManager = ( { project }: { project: Project } ) => {
	const snackbarSystem = useSnackbarSystem();

	const { mutate: accessProjectAsManager } = useAccessProjectAsManagerMutation( {
		projectID: project.id,
		workspaceID: project.workspaceID,
		onSuccess: () => {
			snackbarSystem.showSuccessMessage( { title: 'You are now a manager of this project' } );
		}
	} );

	return accessProjectAsManager;
}

export default useAccessProjectAsManager;
